import React from "react";
import { NavLink } from "react-router-dom";
const AboutBanner = () => {
  return (
    <>
      <section className="banner-area">
        <div className="container">
          <div className="breadcrumb-area">
            <h1>About Us</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink >Home</NavLink>
                </li>
                <li className="breadcrumb-item">
                  <NavLink >Pages</NavLink>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  About Us
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutBanner;
